
import {
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnInit,
} from '@angular/core';

import { NDDFormErrorService } from '../ndd-ng-form-error/shared/ndd-ng-form-error.service';
import { NDDFormsBaseComponent } from '../shared/ndd-ng-forms.base-component';

/** Componente radio. */
@Component({
    selector: 'ndd-ng-form-radio',
    template: require('./ndd-ng-form-radio.component.html'),
})
export class NDDFormRadioComponent extends NDDFormsBaseComponent implements OnInit {
    private static MULTI_OPTIONS_MARGIN_BOTTOM_REM: string = '0.75rem'; // 12px.

    /** Define se está marcado (checked). */
    @Input() public controlChecked: boolean;

    constructor(@Inject(Window) private window: Window, formErrorService: NDDFormErrorService, cdr: ChangeDetectorRef) {
        super(formErrorService, cdr);
    }

    public ngOnInit(): void {
        /*
         * Caso sejam múltiplas opções radio, define o valor para o controle, conforme `controlChecked`.
         *
         * Devido ao elemento radio ter os mesmos nomes de controle, o Angular não cria vários controles iguais no formulário;
         * caso já tenha o controle, apenas retorna-o.
         */
        if (this.controlForm.get(this.controlKey) && this.controlChecked) {
            this.controlForm.get(this.controlKey).setValue(this.controlValue);
        }

        super.addControl();
        super.addValidators();

        if (!this.controlDescriptions) {
            this.controlDescriptions = [this.controlDescription];
        }
    }

    public checked(): void {
        this.controlValueChange.emit(this.controlValue);
    }

    /** Define `margin-bottom` para `12px` quando os radios forem múltipla opção. */
    public setMarginBottom(): string {
        const elemList: NodeListOf<HTMLElement> = this.window.document.getElementsByName(this.controlKey);
        const isMultiOptions: boolean = elemList.length > 1;

        // Mantém margem padrão, se não for múltipla opção ou se for a última opção.
        if (!isMultiOptions) { return; }
        if (elemList[elemList.length - 1].id === this.controlId) { return; }

        return NDDFormRadioComponent.MULTI_OPTIONS_MARGIN_BOTTOM_REM;
    }

    protected addControl(): void {
        if (!this.controlId) {
            throw new Error('É necessário definir `controlId` para elementos de formulário.');
        }

        super.addControl();
    }
}
